var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2426 12L16.2929 7.05025C15.9024 6.65973 15.9024 6.02656 16.2929 5.63604C16.6834 5.24552 17.3166 5.24552 17.7071 5.63604L23.364 11.2929C23.7545 11.6834 23.7545 12.3166 23.364 12.7071L17.7071 18.364C17.3166 18.7545 16.6834 18.7545 16.2929 18.364C15.9024 17.9734 15.9024 17.3403 16.2929 16.9497L21.2426 12Z",
    fill: "#4C4C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.336804e95bac8e2e87b6334edb409e20.svg";
export { ForwardRef as ReactComponent };